import customerConfig from "emun.customer/customer.config";
import deleteConfirmationTemplate from "emun.retailer/retailer-shipping-location-delete-confirmation.htm";
import fieldsetTemplate from "emun.retailer/retailer-shipping-location-fieldset.htm";
import retailerConfig from "emun.retailer/retailer.config";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";
import { ModelPrompt, ModelPromptController } from "webmodals/model-prompt";

export class RetailerShippingLocationPromptController extends ModelPromptController {
  constructor($uibModalInstance, options) {
    super(options);
    const $ctrl = this;
    $ctrl.modal = $uibModalInstance;
    $ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
    $ctrl.$close = $ctrl.close = $uibModalInstance.close;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.config = retailerConfig;
    $ctrl.customerConfig = customerConfig;
    console.debug("ship promp request", $ctrl.request, $ctrl, $ctrl.customerId);
    if ($ctrl.request.retailerId == undefined) {
      $ctrl.request.retailerId = $ctrl.customerId;
    }
    const retailerId = $ctrl.request.retailerId;
    const id = $ctrl.request.id;

    ServiceBus.send(
      "QueryRetailerShippingLocations.json?Fields=Address,City,State,Zip,Id,Name,Status&RetailerId=" +
        retailerId
    ).then(
      (res) =>
        ($ctrl.otherLocations = res.data.results.filter((m) => m.id !== id))
    );
    ServiceBus.send("QueryRetailers.json?Id=" + retailerId).then(
      (res) => ($ctrl.retailer = res.data.results[0])
    );
  }

  copyFromBilling() {
    const $ctrl = this;
    $ctrl.request.name = $ctrl.retailer.companyName;
    $ctrl.request.address = $ctrl.retailer.address;
    $ctrl.request.address2 = $ctrl.retailer.address2;
    $ctrl.request.city = $ctrl.retailer.city;
    $ctrl.request.state = $ctrl.retailer.state;
    $ctrl.request.zip = $ctrl.retailer.zip;
    $ctrl.request.phone = $ctrl.retailer.phone;
  }
  checkDuplicateZip() {
    const $ctrl = this;
    $ctrl.duplicateZips = ($ctrl.otherLocations || []).filter(
      (m) =>
        m.id !== $ctrl.request.id &&
        $ctrl.request.zip &&
        $ctrl.request.zip.length >= 5 &&
        m.zip.startsWith($ctrl.request.zip.substring(0, 5))
    );
  }
  duplicateZip() {
    const $ctrl = this;
    return true;
  }
}

export default class RetailerShippingLocationPrompt extends ModelPrompt {
  constructor() {
    super();
    this.seed = {
      status: "Active",
      retailerId: $session.retailerId || this.customerId,
      country: customerConfig.defaultCountry || "US",
      salesReps: [
        $session.salesRepId || $session.userAuthName || $session.userName,
      ],
    };
  }
  mapModel(model) {
    model.companyName = model.name;
    return model;
  }
  getController(model, action) {
    return RetailerShippingLocationPromptController;
  }
  // getTitle(model, action) {
  //   return `${action} shipping location...`;
  // }
  getTitle(model, action) {
    return `${action} an Address`;
  }
  getSubTitle(model, action) {
    return `sub title shipping location...`;
  }
  getQueryUrl(model, action) {
    return (
      `QueryRetailerShippingLocations.json?RetailerId=` +
      model.retailerId +
      `&Id=${model && model.id}`
    );
  }
  getCommandUrl(model, action) {
    return `${action}RetailerShippingLocation.json`;
  }
  getModalBodyTemplateUrl(model, action) {
    return action === "Delete" ? deleteConfirmationTemplate : fieldsetTemplate;
  }
  //getModalFooterLeftTemplateUrl(model, action) { return footerLeftTemplate; }
}
